



























import Vue from 'vue';
import gql from 'graphql-tag';
import { mapKeys, upperFirst, get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';
import ObjectMapper, { ObjectModel } from '@/components/object_mapper/ObjectMapper.vue';
import { ObjectsQuery } from '@/graphql/MapperObjects';

export default Vue.extend({
  name: 'ObjectMapperModal',
  components: {
    ObjectMapper,
    LoadingSpinner,
    GenericCard,
  },
  props: {
    rightType: {
      type: String,
      default: null,
    },
    objectIds: {
      type: String,
      default: '',
    },
    mappings: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      mappedObjects: null,
      leftColumnObjects: [],
    };
  },
  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      apiEndpoints: 'objectMapperApiEndpoints',
      rawAvailableMapTypes: 'availableMapTypes',
      modelMeta: 'modelMeta',
      modelMetaFindBy: 'modelMetaFindBy',
      routes: 'routes',
    }),
    rightColumnType() {
      return this.rightType ? this.getModelType(this.rightType) : undefined;
    },
    rightColumnObjects() {
      return this.objects
        ? this.objects.map(n => {
            const mappedObject = this.mappings.find(o => o.id === n.dbId);
            return {
              id: n.dbId,
              identifier: n.identifier.value,
              title: n.title.value,
              mapped: mappedObject ? mappedObject.mapped : false,
              selected: false,
            };
          })
        : null;
    },
    availableMapTypes() {
      return mapKeys(this.rawAvailableMapTypes, (_, key) => upperFirst(key));
    },
    loading() {
      return this.$apollo.queries.objects.loading;
    },
  },
  created() {
    this.changeModalSize(ModalSize.Medium);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
    }),
    getModelType(type: string): ObjectModel | undefined {
      const modelMeta = this.modelMetaFindBy('modelSingular', type.replace(/ /g, ''));
      if (!modelMeta) return;
      return {
        model: modelMeta.modelSingular,
        plural: modelMeta.titlePlural,
        singular: modelMeta.titleSingular,
      };
    },
    save() {
      this.confirmModal(this.mappedObjects);
      this.mappedObjects = null;
    },
    cancel() {
      this.mappedObjects = null;
      this.cancelModal();
    },
    onMappingItems({ mapped }) {
      this.mappedObjects = mapped;
    },
  },
  apollo: {
    objects: {
      query() {
        return gql(ObjectsQuery(this.rightColumnType.model));
      },
      update(result) {
        const objects = get(result, 'search.edges');
        if (objects) return objects.map(o => o.node);
      },
      error() {
        this.showAlert({
          type: 'error',
          message: 'Failed to load objects.',
        });
      },
    },
  },
});
